import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_WORK_GROUP_BY_ID } from "../Schema/WorkGroup";

export const useGetWorkGroupById = ({ id }) => {

  const [loading, setLoading] = useState(true);
  const [workGroupData, setWorkGroupData] = useState([]);

  const { refetch: refetchWorkGroupById } = useQuery(GET_WORK_GROUP_BY_ID, {
    variables: {
      id: id,
    },
    onCompleted: ({ getWorkGroupById }) => {
      
        setWorkGroupData(getWorkGroupById || []);
        setLoading(false);
    },
    onError: (err) => {
        console.log("Error::", err?.message);
    },
  });

    useEffect(() => {
        refetchWorkGroupById();
    }, []);


  return { workGroupData, refetchWorkGroupById };
};
